import { ArrowUp, ArrowDown, Icon } from "react-bootstrap-icons";

export type PillType =
  | "primary"
  | "secondary"
  | "info"
  | "success"
  | "warning"
  | "danger";

export const getSeverityColor = (severityName?: string): PillType => {
  const normalized = severityName?.toLowerCase() || "";
  switch (normalized) {
    case "critical":
      return "secondary";
    case "high":
      return "danger";
    case "medium":
      return "warning";
    case "low":
      return "info";
    default:
      return "secondary";
  }
};

export const getStatusColor = (statusName?: string): PillType => {
  const normalized = statusName?.toLowerCase() || "";
  switch (normalized) {
    case "approved":
      return "success";
    case "pending":
      return "info";
    case "need-review":
    case "need review":
      return "warning";
    case "refused":
      return "danger";
    default:
      return "info";
  }
};

export const getSeverityIcon = (severityName?: string): Icon => {
  const normalized = severityName?.toLowerCase() || "";
  switch (normalized) {
    case "critical":
    case "high":
      return ArrowUp;
    case "medium":
    case "low":
      return ArrowDown;
    default:
      return ArrowUp;
  }
};

export const isBugEditable = (statusName?: string): boolean => {
  const normalized = statusName?.toLowerCase() || "";
  return (
    normalized === "pending" ||
    normalized === "need-review" ||
    normalized === "need review"
  );
};
